import { Component, OnInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore, DocumentSnapshot } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-vendedores',
  templateUrl: './vendedores.component.html',
  styleUrls: ['./vendedores.component.scss']
})
export class VendedoresComponent implements OnInit {

  private itemsCol: AngularFirestoreCollection<any>;
  public  items:    Observable<any>;
  public  item: any;
  public  exist: boolean;

  public rutas : Map<string,string>;

  public circuitos : Map<string,Map<string,string>>;

  public displayedColumns = ["cedula", "nombre", "celular", "ruta", /*"circuito",*/ "totalRecargas", "options" ];

  constructor(private afFirestore: AngularFirestore,
    private snackBar: MatSnackBar) {
    this.rutas = new Map<string,string>();
    //this.circuitos = new Map<string,Map<string,string>>();
  }

  ngOnInit() {
    this.itemsCol = this.afFirestore.collection<any>("vendedor", ref => ref.where("celular", ">", ""));
    this.items    = this.itemsCol.valueChanges();
    this.afFirestore.collection<any>("punto-venta")
      .valueChanges()
      .subscribe(
        (valueChanges)=>{
          valueChanges.forEach(            
            (valueChange)=>{
              if( !this.rutas.has(valueChange["ruta"]) ){
                this.rutas.set(valueChange["ruta"], valueChange["ruta"]);                
                //this.circuitos.set(valueChange["ruta"], new Map<string,string>());
              }
              /*
              if( !this.circuitos.get(valueChange["ruta"]).has(valueChange["circuito"]) ){
                this.circuitos.get(valueChange["ruta"]).set(valueChange["circuito"], valueChange["circuito"]);
              }
              */
            }
          );
        }
      );
  }

  showList(){
    this.item = null;
  }

  showCreate(){
    this.exist = false;
    this.item = {
      cedula: "",
      nombre: "",
      celular: "",
      ruta: ""
    };
  }  

  showUpdate(item){
    this.exist = true;    
    this.item = item;
  }

  create(){
    var itemRef = this.itemsCol.doc(""+this.item.cedula).ref;
    itemRef.get()
      .then(
        (documentSnapshot: DocumentSnapshot<any>)=>{
          if( documentSnapshot.exists ){
            this.snackBar.open("Ya existe un vendedor con la cedula: "+this.item.cedula,"Entiendo",{duration: 2000});
          }
          else{
            itemRef.set(this.item, { merge: true })
              .then(
                ()=>{
                  this.showList();
                }
              );
          }
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado creando el vendedor","Entiendo",{duration: 2000});
        }
      );  
  }

  update(){
    var itemRef = this.itemsCol.doc(""+this.item.cedula).ref;
    itemRef.set(this.item, { merge: true })
      .then(
        ()=>{
          this.showList();
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado actualizando el vendedor","Entiendo",{duration: 2000});
        }
      );  
  }

  showDelete(item){
    if(confirm("¿Esta seguro de querer eliminar a este vendedor?")){
      var itemRef = this.itemsCol.doc(""+item.cedula).ref;
      itemRef.delete()
        .then(
          ()=>{
            this.showList();
          }
        )
        .catch(
          (error)=>{
            this.snackBar.open("Error inesperado eliminando el vendedor","Entiendo",{duration: 2000});
          }
        );
    }
  }

}
